module.exports = __webpack_public_path__ + "media/total-monthly-price-with-fee-acknowledgement-clipboard.2b4cb3c2.svg";